module.exports = __webpack_public_path__ + "static/the-curious-incident-of-the-dog-in-the-nighttime-2bf54bc4bca2e1ecc4c9933479c72165.jpg";